// removed by extract-text-webpack-plugin
module.exports = {"root":"_39Hd1","title":"_3McSV","desc":"_JbM05"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@snapask/common-components/styles/simpleDialogTheme/white.scss
// module id = 341
// module chunks = 34